window.showLoadingIndicator = function() {
  $('<div id="loading"><div></div></div>').appendTo('body');
}

window.hideLoadingIndicator = function() {
  $('body > #loading').remove();
}
